import { ArrowRight, Lock } from "lucide-react";

export const OffMarketSection = () => {
  return (
    <section 
      className="py-16 md:py-24 lg:py-32 bg-[#0A0A0B] relative overflow-hidden"
      data-testid="off-market-section"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      
      {/* Decorative corner accents */}
      <div className="absolute top-12 left-12 w-20 h-20 border-l border-t border-[#D4AF37]/15 hidden lg:block" />
      <div className="absolute bottom-12 right-12 w-20 h-20 border-r border-b border-[#D4AF37]/15 hidden lg:block" />
      
      <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-10 md:mb-12">
          <div className="inline-flex items-center gap-2 mb-4">
            <Lock className="w-4 h-4 text-[#D4AF37]" />
            <span className="text-[#D4AF37] text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] uppercase font-semibold">
              Exclusive Access
            </span>
          </div>
          <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-white leading-tight">
            Private Off-Market
            <span className="block text-[#D4AF37] italic mt-2">Property Opportunities</span>
          </h2>
          <div className="w-16 md:w-20 h-px bg-[#D4AF37] mx-auto mt-6 md:mt-8" />
        </div>

        {/* Content */}
        <div className="text-center max-w-3xl mx-auto space-y-6 mb-10 md:mb-12">
          <p className="text-white/70 text-sm md:text-base lg:text-lg leading-[1.9] md:leading-[2]">
            Certain premium properties are not publicly advertised for privacy and security reasons.
          </p>
          
          <p className="text-white/70 text-sm md:text-base lg:text-lg leading-[1.9] md:leading-[2]">
            4 ACES Attorneys occasionally introduces off-market property opportunities to qualified 
            investors seeking high-value residential or commercial assets in Abuja and other major 
            cities in Nigeria.
          </p>
          
          <p className="text-white/70 text-sm md:text-base lg:text-lg leading-[1.9] md:leading-[2]">
            These opportunities are shared privately with serious buyers who contact our office.
          </p>
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <a
            href="#booking"
            className="inline-flex items-center gap-2 md:gap-3 bg-[#D4AF37] text-[#0A0A0B] px-8 md:px-10 py-4 md:py-5 font-semibold text-sm tracking-wide hover:bg-[#C5A028] transition-colors"
            data-testid="off-market-cta"
          >
            Request Private Property Opportunities
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};
